export default __webpack_public_path__ + "156ececceb1913d9eb8a5274808b611f.woff2";